import { motion } from "framer-motion";
import { Award, Trophy, Medal, Star, ShieldCheck, BadgeCheck } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";

const AWARDS = [
  {
    title: "Retention Excellence Award",
    org: "TallyPrime H1 FY 2024-25",
    icon: Trophy,
    image: "/gallery/tallyprime-retention-excellence-award-h1-fy-2024-25.jpg",
  },
  {
    title: "Certificate of Appreciation",
    org: "Customer Retention H1 FY 2024-25",
    icon: Award,
    image: "/gallery/certificate-appreciation-tallyprime-customer-retention.jpg",
  },
  {
    title: "Customer Connect Champion",
    org: "UP East FY 2025-26",
    icon: Medal,
    image: "/gallery/customer-connect-champ-award-ceremony-fy-2025-26.jpg",
  },
  {
    title: "Certificate of Honor",
    org: "Certified Partner Day 2025",
    icon: Star,
    image: "/gallery/certificate-of-honor-certified-partner-day-2025.jpg",
  },
  {
    title: "3-Star Certified Partner",
    org: "Sales & Implementation",
    icon: ShieldCheck,
    image: "/gallery/tally-3-star-sales-implementation-partner-certificate.jpg",
  },
  {
    title: "Business Catalyst FY 2023-24",
    org: "Customer Management",
    icon: BadgeCheck,
    image: "/gallery/business-catalyst-customer-management-fy-2023-24.jpg",
  },
];

export default function Awards() {
  return (
    <section
      data-testid="awards-section"
      className="relative py-16 lg:py-20 border-y border-[#0D47A1]/10 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          variants={stagger(0.1, 0.08)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="text-center mb-12"
        >
          <motion.span variants={fadeUp} className="eyebrow"><span className="dot" /> Awards & Recognition</motion.span>
          <motion.h2 variants={fadeUp} className="mt-5 font-display font-black text-3xl sm:text-4xl leading-[1.08] tracking-tight text-[#1A1A2E]">
            Recognized for <span className="font-serif-accent text-[#FFA000]">excellence.</span>
          </motion.h2>
          <motion.p variants={fadeUp} className="mt-3 text-[15px] text-[#4A5568] max-w-lg mx-auto">
            Awarded by industry leaders for outstanding service delivery and customer satisfaction.
          </motion.p>
        </motion.div>

        <motion.div
          variants={stagger(0.06, 0.08)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4"
        >
          {AWARDS.map(({ title, org, icon: Icon, image }, i) => (
            <motion.div
              key={title}
              variants={fadeUp}
              whileHover={{ y: -4 }}
              className="group relative rounded-2xl overflow-hidden bg-[#FAF9F6] border border-[#0D47A1]/8 hover:border-[#FFA000]/30 transition-all duration-400"
            >
              {/* Award image */}
              <div className="relative h-32 overflow-hidden">
                <img src={image} alt={title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#FAF9F6] via-[#FAF9F6]/20 to-transparent" />
                <div className="absolute bottom-2 left-1/2 -translate-x-1/2">
                  <div className="w-10 h-10 rounded-xl bg-[#FFA000] flex items-center justify-center shadow-[0_8px_20px_rgba(255,160,0,0.3)]">
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                </div>
              </div>
              {/* Text */}
              <div className="p-3 text-center">
                <h4 className="font-display font-bold text-[13px] text-[#1A1A2E] leading-tight">{title}</h4>
                <p className="mt-1 text-[11px] text-[#8896A6]">{org}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
